var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 84,
    viewBox: "0 0 96 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 80c-2.553-1.67-31.284-20.75-40.08-40.298A23.536 23.536 0 0 1 5.333 28.94c0-13.015 10.49-23.607 23.376-23.607 7.512 0 14.621 3.705 19.016 9.907l.275.387.276-.387c4.387-6.202 11.496-9.907 19.015-9.907 12.894 0 23.376 10.592 23.376 23.607 0 3.759-.867 7.376-2.58 10.748C79.285 59.25 50.553 78.33 48 80z",
    fill: "url(#dvh84qivoa)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "dvh84qivoa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 63.3333 -149.845 0 48 18.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like_icon.d8c093f6d9e986b0c599ede0f3ed6ce0.svg";
export { ForwardRef as ReactComponent };